import type { AppProps } from "next/app";
import { I18nProvider } from "next-localization";
import type { SitecorePageProps } from "lib/page-props";
import { ChakraProvider } from "@chakra-ui/react";

import theme from "themes/index";
import Bootstrap from "src/Bootstrap";
import UtmCapture from "commons/UtmCapture";
import { GoogleTagManager } from "@next/third-parties/google";

function App({ Component, pageProps }: AppProps<SitecorePageProps>) {
    const { dictionary, ...rest } = pageProps;

    const gtmAccount = process.env.NEXT_PUBLIC_GTM_ACCOUNT;
    const gtmAccountsSplit = gtmAccount?.includes("|") ? gtmAccount.split("|") : [gtmAccount];

    return (
        <>
            {gtmAccountsSplit.map((id) => id && <GoogleTagManager gtmId={id} key={id} />)}
            <Bootstrap {...pageProps} />
            <UtmCapture />
            <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
                <ChakraProvider theme={theme}>
                    <Component {...rest} />
                </ChakraProvider>
            </I18nProvider>
        </>
    );
}

export default App;
